import React, { useRef, useEffect } from 'react';
import './slide.css';
import ReactPlayer from 'react-player';

const VideoSlide = (props) => {
  const { url, playing, muted = true, setIsLoading = () => {} } = props;
  const playerRef = useRef(null);

  useEffect(() => {
    if (!playing) {
      seekToStart();
    }
  }, [playing]);

  const seekToStart = () => {
    if (playerRef) {
      playerRef.current.currentTime = 0;
      console.log(`Reset video to start ${url}`);
    }
  };

  return (
    <div>
      <ReactPlayer
        ref={playerRef}
        className="video"
        src={url}
        muted={muted}
        playing={playing}
        width='100%'
        height='100%'
        onReady={() => setIsLoading(false)}
      />
    </div>
  );
};

export default VideoSlide;
